<span *ngFor="let breadcrumb of breadcrumbArray; index as i" class="breadcrumb-item">
    {{breadcrumb}}
    <fa-icon icon="chevron-right" *ngIf="i < (breadcrumbArray.length - 1)" class="icon"></fa-icon>
</span>
